import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { eventListener } from "../../events";
import { types } from "../../events/loader";
import "./style.css";



export const Loader = ({ forceShown = false }) => {
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        eventListener(types.SET_LOADER, () => setIsShown(true));
        eventListener(types.UNSET_LOADER, () => setIsShown(false));
    }, []);

    return (
        <div id="loader" className={forceShown || isShown ? "show" : "unshow"}>
            <CircularProgress className="circular-progress" />
        </div>
    );
};
